exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".goods-list-template[data-v-13bdb71a]{min-height:100px;margin-top:-35px}", ""]);

